import React from 'react';
import styles from './LegalPage.module.css';

const sections = [
	{
		title: 'Using Calcium',
		paragraphs: [
			'Calcium is a fitness platform for creating, tracking, sharing, and joining workout routines. By using the app, website, or related services, you agree to use Calcium responsibly and in line with these terms.',
			'You must provide accurate account information, keep your login details secure, and only use the service in ways that comply with applicable laws and the safety of other members.',
			'Do not submit passwords, payment card details, or highly sensitive medical information through messages, optional notes, or other free-text fields in the product.'
		]
	},
	{
		title: 'Health and training guidance',
		paragraphs: [
			'Calcium may provide workout plans, meal ideas, AI-generated recommendations, and coaching-style prompts, including content from Cali. This content is for informational and educational purposes only and is not medical advice, diagnosis, or treatment.',
			'You are responsible for listening to your body, adjusting intensity, and consulting a qualified professional before starting or changing any training, nutrition, or wellness program.'
		]
	},
	{
		title: 'Memberships and paid features',
		paragraphs: [
			'Some parts of Calcium may require a paid subscription. If you purchase a plan, you authorize the relevant app store, payment processor, or billing platform to charge you according to the pricing shown at checkout.',
			'Paid features, pricing, and availability may change over time. Unless required by law, subscription payments are non-refundable once a billing period has started.'
		]
	},
	{
		title: 'Community content and routines',
		paragraphs: [
			'You keep ownership of the content you create, including routines, comments, profile details, and posts. By publishing or sharing that content through Calcium, you give us permission to host, display, and distribute it as needed to operate the service.',
			'Do not post unlawful, abusive, misleading, infringing, or unsafe content. We may remove content or restrict access if it harms the community, violates these terms, or puts other users at risk.'
		]
	},
	{
		title: 'Private messages and security',
		paragraphs: [
			'Calcium uses security measures, including encryption, to help safeguard potentially sensitive user data.',
			'Please avoid sharing passwords, payment card details, or highly sensitive medical information through messages, notes, or other free-text fields.'
		]
	},
	{
		title: 'Invites, sharing, and account limits',
		paragraphs: [
			'Workout invitations, participation features, and sharing tools are meant to help creators train with others. You may only invite others to routines you own or are authorized to manage.',
			'We may limit, suspend, or disable features if we detect spam, abuse, automated misuse, fraud, or attempts to bypass product restrictions.'
		]
	},
	{
		title: 'Availability and changes',
		paragraphs: [
			'We work to keep Calcium fast, reliable, and secure, but we cannot guarantee uninterrupted availability. Features may be updated, improved, limited, or discontinued as the product evolves.',
			'We may update these terms from time to time. Continued use of Calcium after changes take effect means you accept the revised terms.'
		]
	},
];

const TermsPage = () => (
	<div className={styles.LegalPage}>
		<header className={styles.Hero}>
			<span className={styles.Eyebrow}>Legal</span>
			<h1 className={styles.Title}>Terms of Service</h1>
			<p className={styles.Intro}>
				These terms explain the rules for using Calcium and its fitness, community, and AI-powered features.
				They are written to match how the product works today: structured training, social routines, premium plans,
				and practical coaching support.
			</p>
			<p className={styles.Meta}>Last updated: March 2026</p>
		</header>

		<div className={styles.SectionList}>
			{sections.map((section) => (
				<section key={section.title} className={styles.SectionCard}>
					<h2 className={styles.SectionTitle}>{section.title}</h2>
					{section.paragraphs.map((paragraph) => (
						<p key={paragraph} className={styles.Paragraph}>{paragraph}</p>
					))}
				</section>
			))}
		</div>

		<section className={styles.ContactCard}>
			<h2 className={styles.SectionTitle}>Contact</h2>
			<p className={styles.Paragraph}>
				If you have questions about these terms, contact Calcium at <a href='mailto:hello@calcium.fitness'>hello@calcium.fitness</a>.
			</p>
			<p className={styles.Paragraph}>
				Calcium is operated by Projekt Kinetic. Engima Works.
			</p>
		</section>
	</div>
);

export default TermsPage;
